/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignMe32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M16.005 15.787c.658 0 1.26-.175 1.804-.525.543-.35.978-.821 1.305-1.415.326-.594.49-1.26.49-1.995a3.896 3.896 0 00-1.8-3.332 3.296 3.296 0 00-1.8-.52 3.29 3.29 0 00-1.808.524c-.547.35-.983.816-1.31 1.397a3.825 3.825 0 00-.48 1.94c0 .73.162 1.392.485 1.986a3.817 3.817 0 001.3 1.415c.544.35 1.149.525 1.814.525zM21.43 24c.777 0 1.316-.12 1.618-.357.301-.239.452-.571.452-.998 0-.57-.176-1.162-.527-1.777-.35-.616-.854-1.193-1.51-1.731s-1.445-.976-2.368-1.313c-.923-.338-1.953-.506-3.09-.506-1.144 0-2.177.168-3.1.506-.923.337-1.712.775-2.368 1.313-.656.538-1.16 1.115-1.51 1.73-.351.616-.527 1.209-.527 1.778 0 .427.15.76.452.998.302.238.838.357 1.608.357h10.87z"
        />
    </AccessibleSVG>
);

export default SignMe32;
